module.exports = __webpack_public_path__ + "img/empty-state.17ca9579.svg";